import React from "react";
import "./header.css";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { LOG_OUT } from "../../reduxToolKit/features/allAsyncActionReducers/AllAsyncActionReducersSlice";
function Header() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    newMailValid,
    currentUser,
    currentUserIsAdmin,
    currentUserIsLawyer,
    currentUserIsCustomer,
    currentUserIsActive,
  } = useSelector((state) => state.mainReducer);
  const Redirector = () => {
    if(sessionStorage.getItem('type') == 'admin'){
      navigate("/admin/lawyers")
    }

    if(sessionStorage.getItem('type') == 'Client')
    {

      navigate("/lawyers/customer");
    }
    if(sessionStorage.getItem('type') == 'lawyer')
    {

       navigate("/admin/lawyerRequest");
    }

  };

  return (
    <nav>
      <div className="nav-wrapper nav">
        <img className="hdimg" src="/Lawyers.png" alt="" />
        <a href="#" className="brand-logo">
          Lawyers Online
        </a>

        <ul id="nav-mobile" className="right hide-on-med-and-down">
          <li>
            <Link to="/">
              <a className="third">Home</a>
            </Link>
          </li>
          <li>
            {sessionStorage.getItem('type')!==null ? null : (
              <Link to="/registration">
                <a className="third">Register</a>
              </Link>
            )}
          </li>
          <li>
            {sessionStorage.getItem('type')!==null ? (
              <Link to="/">
                <a
                  className="third"
                  href="collapsible.html"
                  onClick={() => {
                   sessionStorage.clear()
                  }}
                >
                  Log Out
                </a>
              </Link>
            ) : (
              <Link to="/login">
                <a className="third" href="collapsible.html">
                  Login
                </a>
              </Link>
            )}
          </li>

          {/* {currentUserIsActive ? ( */}
            <>
            {sessionStorage.getItem('type')=='Client' ?  (
             <> <li>
             <Link to="/services">
               <a className="third" href="collapsible.html">
                 Services
               </a>
             </Link>
           </li>
           <li>
             <Link to="/aboutus">
               <a className="third" href="collapsible.html">
                 About Us
               </a>
             </Link>
           </li>
           </>
            ):
            null}
                {sessionStorage.getItem('type')=='Client'?
              <li>
                <Link to="/cases">
                  <a className="third" href="collapsible.html">
                    File Case
                  </a>
                </Link>
              </li>
              : null
                }

                {sessionStorage.getItem('type')!==null ?
              <li>
                <a className="third" onClick={Redirector}>
                  Dashboard
                </a>
              </li>:
              null
                }
            </>
          {/* ) : null} */}
        </ul>
      </div>
    </nav>
  );
}

export default Header;
